import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 17 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M11.412 10.667a3.554 3.554 0 0 1-3.446 2.666h-2.89a3.547 3.547 0 0 1-3.555-3.538V4.049a1.387 1.387 0 0 1 1.39-1.382h7.22l.001.666v-.666a1.387 1.387 0 0 1 1.389 1.382v.618h1c1.244 0 2.333.952 2.333 2.222v1.556c0 1.27-1.09 2.222-2.333 2.222zM2.887 4.004 2.907 4h7.227a.053.053 0 0 1 .053.053v5.742A2.213 2.213 0 0 1 7.967 12h-2.89a2.214 2.214 0 0 1-2.222-2.205V4.053a.05.05 0 0 1 .033-.049M11.521 6v3.333h1c.596 0 1-.44 1-.888V6.889c0-.448-.404-.889-1-.889z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })